import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class serviceAreaSegmentsViewCtrl implements IController {

  segments: any;
  priorities: any;
  minTime: any;
  maxTime: any;
  isEdit: boolean;
  branchIds: any;
  serviceAreaOptionIds: any;
  onAddSegment: Function;
  onSegmentFromChange: Function;
  onSegmentToChange: Function;
  onAddServiceArea: Function;
  onRemoveServiceArea: Function;
  onRemoveSegment: Function;
  onSetSegmentDurationInMillis: Function;

  public excludeIdsBySegment: any;
  private showWarning: any;
  private durationsMap: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

    this.showWarning = {
      isShow: false,
      segmentId: undefined
    }

    this.durationsMap = this.onSetDurationsInMinutes();

    this._setExcludedAreaIdsMap();
  }

  $onChanges(changes) {
    if (changes.segments && !changes.segments.isFirstChange()) {
      if (_.get(this.segments, 'length')) {
        this.durationsMap = this.onSetDurationsInMinutes();
      }
    }

    if (changes.minTime && !changes.minTime.isFirstChange()) {
      if (_.get(this.segments, 'length')) {
        const minTimeCurrentValue = _.get(changes, 'minTime.currentValue'),
              minTimePreviousValue = _.get(changes, 'minTime.previousValue');

        // if ((!!minTimePreviousValue && !!minTimeCurrentValue)) {
        //   const millisecondsDiff = (minTimePreviousValue - minTimeCurrentValue);
        //   this.segments.forEach((s) => {
        //     s.offsetInMillis = s.offsetInMillis + millisecondsDiff;
        //   })
        // }

        // this._onResetSegmentTime();
        this.durationsMap = this.onSetDurationsInMinutes();
      }
    }

    if (changes.maxTime && !changes.maxTime.isFirstChange()) {
      if (_.get(this.segments, 'length')) {
        // this._onResetSegmentTime();
        this.durationsMap = this.onSetDurationsInMinutes();
      }
    }
  };


  displaySegmentStartTime(offsetInMillis) {
    return this.minTime + offsetInMillis;
  }

  displaySegmentEndTime(offsetInMillis, durationInMillis, segmentId) {
    if (durationInMillis <= 0) {
      this.showWarning = {
        isShow: true,
        segmentId: segmentId
      };
      this.onSegmentToChange({date: this.minTime + offsetInMillis + 900000, segmentId: segmentId});

      setTimeout(() => {
        this.showWarning = {
          isShow: false,
          segmentId: segmentId
        };
      }, 2000);

      return this.minTime + offsetInMillis + 900000;
    }
    return {durationInMillis: this.minTime + offsetInMillis + durationInMillis};
    // return this.minTime + offsetInMillis + durationInMillis;
  }

  onSetDurationsInMinutes() {
    if (_.get(this.segments, 'length')) {
      const durationsMap = _.map(this.segments, (segment) => {
        return {
          segmentId: segment.id,
          durationInMillis: segment.durationInMillis,
          durationInMinutes: segment.durationInMillis > 0 || segment.durationInMillis < 0 ? segment.durationInMillis / 60000 : 0
        }
      });

      return _.mapKeys(durationsMap, (value, key) => {
        return value.segmentId;
      });

    } else return [];
  }

  onSelectServiceAreas(serviceArea, segmentId, areaId) {
    const segmentIdx = _.findIndex(this.segments, (s: any) => {
      return s.id === segmentId;
    })
    const selectedSegment = this.segments[segmentIdx];
    const areaIdx = _.findIndex(selectedSegment.planningAreas, (area: any) => {
      return area.id === areaId;
    });
    selectedSegment.planningAreas[areaIdx].areaId = _.get(serviceArea, 'areaId');

    this._setExcludedAreaIdsMap();
  }

  // _onResetSegmentTime() {
  //   _.forEach(this.segments, (s) => {
  //     this.onSegmentFromChange({date: this.minTime, segmentId: s.id});
  //     this.onSegmentToChange({date: this.maxTime, segmentId: s.id});
  //   });
  // }

  private _setExcludedAreaIdsMap() {
    this.excludeIdsBySegment = {};
    _.forEach(this.segments, (segment) => {
      const areaIds = _.map(segment.planningAreas, (planningArea) => {
        return planningArea.areaId
      });

      _.set(this.excludeIdsBySegment, [segment.id], areaIds);
    })
  }

}

angular
  .module('bringoz.admin.resources')
  .component('serviceAreaSegmentsView', {
    bindings: {
      segments: '<',
      priorities: '<',
      minTime: '<',
      maxTime: '<',
      isEdit: '<?',
      branchIds: '<',
      serviceAreaOptionIds: '<',
      onAddSegment: '&',
      onSegmentFromChange: '&',
      onSegmentToChange: '&',
      onAddServiceArea: '&',
      onRemoveServiceArea: '&',
      onRemoveSegment: '&',
      onSetSegmentDurationInMillis: '&'
    },
    template: require('./service-area-segments-view.html').default,
    controller: serviceAreaSegmentsViewCtrl
  });
